import React, { FC } from 'react'
import RangeCondition from './RangeCondition'
import listenToClickOutside from 'react-onclickoutside'
import { ConditionName, RangeParams } from '../../actions/index'

type Props = {
  name: ConditionName
  open: boolean
  from?: number
  to?: number
  hasError: boolean
  onRemove: (cond: ConditionName) => any
  onToggle: (cond: ConditionName) => any
  onSet: (cond: ConditionName, range: RangeParams) => any
}

const renderPeopleRangeCondition = (RangeCondition: any): FC<Props> => {
  const peopleRangeConfition = (props: Props) => (
    <RangeCondition {...props} annotation="人" />
  )
  return peopleRangeConfition
}

// @ts-ignore
const PeopleRangeCondition = renderPeopleRangeCondition(
  listenToClickOutside(RangeCondition)
)
// @ts-ignore
PeopleRangeCondition.displayName = 'PeopleRangeCondition'

export default PeopleRangeCondition
